import React from "react";
import { useLayoutEffect } from "react";

export default function LayoutInit() {
  useLayoutEffect(() => {}, []);
  return "";
}
